import { Button } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";
import AllowAccess from "../AllowAccess/AllowAccess";
import "./Card.css";

const getDate = (t) => {
  if (!t) {
    return null;
  }
  // const t = new Date(1970, 0, 1);
  // t.setSeconds(sec);
  const time = t.toLocaleDateString();
  // console.log(t.toISOString().substr(0, 10));
  return time;
};

function Card({ data }) {
  // console.log(data);
  const history = useHistory();

  let tempURL =
    "https://media.istockphoto.com/vectors/user-avatar-profile-icon-black-vector-illustration-vector-id1209654046?k=6&m=1209654046&s=612x612&w=0&h=sNiHvwJm5SPrpTCjz-7eqSDqew5-f2hASM2FrGLtMJ4=";

  const detailsHandler = () => {
    history.push(`/UserData/${data.authID}`);
  };

  return (
    <div className="card">
      <div className="card__leftSide">
        <div className="card__photoContainer">
          <img
            src={data.profilePhotoURL ? data.profilePhotoURL : tempURL}
            className="card__photo"
            alt=""
          />
        </div>
      </div>

      <div className="card__info">
        <div>
          <p>
            <b>Name:</b>{" "}
            {`${data.firstName}${data.middleName ? " " + data.middleName : ""}${
              data.lastName ? " " + data.lastName : ""
            } `}
          </p>
        </div>
        <div>
          <p>
            <b>Email:</b> {data.emailAddress}
          </p>
        </div>
        <div>
          <p>
            <b>Phone:</b> {data.phoneNumber}
          </p>
        </div>
        <div>
          <p>
            <b>Gender:</b> {data.gender === 0 ? "Male" : "Female"}
          </p>
        </div>
        <div>
          <p>
            <b>DOB:</b> {getDate(data?.dateOfBirth?.toDate())}
          </p>
        </div>
        {data.dateOfMarriage ? (
          <div>
            <p>
              <b>Marriage Date:</b> {getDate(data?.dateOfMarriage?.toDate())}
            </p>
          </div>
        ) : null}

        <AllowAccess
          auth={data.isAuthenticated}
          name={data.firstName}
          authID={data.authID}
          token={data.token}
        />
        <Button
          variant="contained"
          color="primary"
          style={{
            color: "white",
            fontSize: "13px",
          }}
          onClick={detailsHandler}
        >
          Edit details
        </Button>
      </div>
    </div>
  );
}

export default Card;
